// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Q1i6n","content":"style_content__O9upg","button":"style_button__C7ebY","title":"style_title__yEHQ8","info":"style_info__Yv1kQ"};